import { render, staticRenderFns } from "./SidebarIcon.vue?vue&type=template&id=208b10c4&scoped=true"
import script from "./SidebarIcon.vue?vue&type=script&lang=js"
export * from "./SidebarIcon.vue?vue&type=script&lang=js"
import style0 from "./SidebarIcon.vue?vue&type=style&index=0&id=208b10c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b10c4",
  null
  
)

export default component.exports